<template>
  <div id="modalAnswer" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Ver Respostas</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <div class="modal-body">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>Pergunta</th>
                <th>Resposta</th>
                <th>Data da Resposta</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="q in questions" :key="q.id">
                <td>{{ q.field1 }}</td>
                <td>{{ q.value }}</td>
                <td>{{ dateTimeSqlToDateTimeBR(q.answerAt) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer border-top-0">
          <button
            type="button"
            class="btn btn-link"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { showModal, hideModal } from '@/utils/modal'
import { dateTimeSqlToDateTimeBR } from '@/utils/date'

export default {
  name: 'AnswersModal',

  props: {
    uuid: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      isLoadingData: true,
      dateTimeSqlToDateTimeBR,
      questions: [],
    }
  },

  methods: {
    async getSurveyQuestions() {
      try {
        this.questions = await this.$store.dispatch(
          'getSurveyQuestionsByUuid',
          this.uuid,
        )
      } catch (error) {
        this.isLoadingData = false
        if (error && error.message) {
          this.hasError = true
          this.messageError = error.message
        } else {
          this.hasError = true
          this.messageError = 'Não foi possível se conectar ao servidor.'
        }
      }
    },
  },

  mounted() {
    this.getSurveyQuestions()
    showModal('modalAnswer')
  },
}
</script>
